import { render } from "./DetailDisposisiMasuk.vue?vue&type=template&id=3aa27dfe&scoped=true"
import script from "./DetailDisposisiMasuk.vue?vue&type=script&lang=js"
export * from "./DetailDisposisiMasuk.vue?vue&type=script&lang=js"

import "./DetailDisposisiMasuk.vue?vue&type=style&index=0&id=3aa27dfe&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa27dfe"]])

export default __exports__